import { StateCreator } from 'zustand'

import { ConnectionEntity } from '../types'

interface ConnectionsState {
  connections: ConnectionEntity[]
}

interface ConnectionsActions {
  addConnection: (conn: ConnectionEntity) => void
  deleteConnection: (id: string) => void
  setConnections: (conns: ConnectionEntity[]) => void
  updateConnection: (conn: ConnectionEntity) => void
}

export type ConnectionsSlice = ConnectionsState & ConnectionsActions

export const initialConnectionsState: ConnectionsState = {
  connections: [],
}

const createConnectionsSlice: StateCreator<ConnectionsSlice, [], [], ConnectionsSlice> = (
  set,
  get,
) => ({
  ...initialConnectionsState,
  addConnection: (newConnection) =>
    set((state) => ({ connections: [...state.connections, newConnection] })),
  deleteConnection: (id) =>
    set((state) => ({
      connections: state.connections.filter((conn) => conn.id !== id),
    })),
  setConnections: (connections) => {
    const prevConnections = get().connections
    if (JSON.stringify(prevConnections) !== JSON.stringify(connections)) {
      set({ connections: connections })
    }
  },
  updateConnection: (updatedConnection) =>
    set((state) => ({
      connections: state.connections.map((connection) =>
        connection.id === updatedConnection.id ? updatedConnection : connection,
      ),
    })),
})

export default createConnectionsSlice
